import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import dateFormat from "dateformat";
import Marquee from "react-fast-marquee";
import { Row, Spinner, Badge } from "reactstrap";
import {
  Box,
  Button,
  Grid,
  TextField,
  Container,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from "@mui/material";
import Autorenew from "@mui/icons-material/Autorenew";

const duration = 2;
const InprogressState = (props) => {
  const { executionStatus, auditDate } = props;

  const datecheck = new Date(auditDate);
  const day = datecheck.getDate();
  const month = datecheck.getMonth() + 1;
  const year = datecheck.getFullYear();
  const hours = datecheck.getHours();
  const minutes = datecheck.getMinutes();

  const finalDate = `${year}-${month}-${day}`;

  const cnow = new Date();
  const currentday = cnow.getDate();
  const currnetmonth = cnow.getMonth() + 1;
  const currentyear = cnow.getFullYear();
  const currnethours = cnow.getHours();
  const currentminutes = cnow.getMinutes();

  const currentDate = `${currentyear}-${currnetmonth}-${currentday}`;

  var dt = moment(datecheck, ["h:mm A"]).format("HH:mm A");
  const [hours1, minutes1] = dt.split(":");
  const extraTime = parseInt(duration) + parseInt(hours1);

  var show;
  if (currentDate === finalDate) {
    if (extraTime <= 24) {
      if (currnethours <= extraTime) {
        show = true;
      } else {
        show = false;
      }
    } else {
      const newvalue = extraTime - 24;
      if (currnethours === newvalue) {
        show = true;
      } else {
        show = false;
      }
    }
  } else {
    show = false;
  }
  return show ? (
    <React.Fragment>
      <span
        style={{
          marginLeft: "5px",
          color: "#19b4e6",
          textTransform: "uppercase",
        }}
      >
        {executionStatus}
      </span>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <span
        style={{
          marginLeft: "5px",
          color: "rgb(228 210 18)",
          textTransform: "uppercase",
        }}
      >
        Time-out
      </span>
    </React.Fragment>
  );
};

const delay = 2;

const Log = () => {
  const [loaddata, setLoaddata] = useState(false);
  useEffect(() => {
    let timer1 = setTimeout(() => setLoaddata(true), delay * 1000);
    return () => {
      clearTimeout(timer1);
    };
  }, []);
  const [hostlist, sethostlist] = useState([]);
  useEffect(() => {
    const hostID = window.sessionStorage.getItem("hostID");
    let isMounted = true;
    fetch(`${process.env.REACT_APP_API_URL}/api/hosts/${hostID}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => sethostlist(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);
  const [remedylist, setremedylist] = useState([]);
  useEffect(() => {
    const rollbackID = window.sessionStorage.getItem("rollbackID");
    let isMounted = true;
    fetch(
      `${process.env.REACT_APP_API_URL}/api/run_rollback_output/${rollbackID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => setremedylist(resp[0]))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const handleUpdateLog = (e) => {
    e.preventDefault;
    const rollbackID = window.sessionStorage.getItem("rollbackID");
    fetch(
      `${process.env.REACT_APP_API_URL}/api/run_rollback_output/${rollbackID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => setremedylist(resp[0]))
      .catch((error) => {
        console.error(error);
      });
  };
  return (
    <>
      {window.localStorage.getItem("audit_run_limit") ===
      "License limitation crossed" ? (
        <Marquee pauseOnHover="false" style={{ color: "red" }}>
          You have utilized all your trail "Audit", Please contact{" "}
          <a
            href="mailto:sales@zippyops.com"
            style={{ marginLeft: "5px", color: "red", paddingRight: "5px" }}
          >
            sales@zippyops.com
          </a>{" "}
          for subscription.
        </Marquee>
      ) : (
        ""
      )}
      <Container>
        <Card className="shadow">
          <div
            className="header bg-gradient-info pb-8 pt-4 pt-md-7"
            style={{
              background:
                "linear-gradient(316deg, #086a7c 0, #0a428d 100%) !important",
            }}
          >
            {loaddata ? (
              <h3
                className="header d-none text-white d-lg-inline-block ml-5"
                style={{
                  fontSize: "24px",
                  fontWeight: "810",
                }}
              >
                {" "}
                Host_name : {hostlist.hostname} <br />
                <h5
                  style={{
                    fontSize: "16px",
                    color: "#fff",
                    fontWeight: "810",
                    marginTop: "4px",
                  }}
                >
                  IP : {hostlist.ip_dns}{" "}
                </h5>
                <h5
                  style={{
                    fontSize: "16px",
                    color: "#fff",
                    fontWeight: "810",
                  }}
                >
                  Executed by : {hostlist.customer}{" "}
                </h5>
                <h5
                  style={{
                    fontSize: "16px",
                    color: "#fff",
                    fontWeight: "810",
                  }}
                >
                  Executed at :{" "}
                  {dateFormat(
                    remedylist.rollback_date,
                    "mmmm dS, yyyy h:MM TT "
                  )}{" "}
                  (IST){" "}
                </h5>
                <h5
                  style={{
                    fontSize: "16px",
                    color: "#fff",
                    fontWeight: "810",
                  }}
                >
                  Reference ID : {remedylist.unique_id}{" "}
                </h5>
              </h3>
            ) : (
              ""
            )}
          </div>
          <CardContent>
            {loaddata ? (
              <Container fluid>
                <Row>
                  <div className="col"></div>
                </Row>
                <Row className="mt-5">
                  <div className="col">
                    <h3 className="mb-0">
                      Rollback Status :
                      {remedylist.execution_status === "Succeeded" ? (
                        <span
                          style={{
                            marginLeft: "5px",
                            color: "lightgreen",
                            textTransform: "uppercase",
                          }}
                        >
                          Completed
                        </span>
                      ) : remedylist.execution_status === "In Progress" ? (
                        <InprogressState
                          executionStatus={remedylist.execution_status}
                          auditDate={remedylist.rollback_date}
                        />
                      ) : (
                        <span
                          style={{
                            marginLeft: "5px",
                            color: "red",
                            textTransform: "uppercase",
                          }}
                        >
                          {remedylist.execution_status}
                        </span>
                      )}
                      <Button
                        color="primary"
                        size="sm"
                        variant="contained"
                        style={{ float: "right", marginLeft: "2px" }}
                        onClick={handleUpdateLog}
                      >
                        Refresh log
                        <i className="mr-2 text-x">
                          <Autorenew size="small" fontSize="small" />
                        </i>
                      </Button>
                      <Button
                        color="primary"
                        size="sm"
                        variant="contained"
                        style={{ float: "right" }}
                      >
                        <Link
                          to={{
                            pathname: "/admin/rollback",
                          }}
                          style={{ color: "#FFF" }}
                        >
                          Back
                        </Link>
                      </Button>
                    </h3>
                    <br />
                    <div
                      style={{
                        whiteSpace: "pre",
                        fontSize: "small",
                        width: "100%",
                        height: "250px",
                        lineHeight: "2",
                        overflow: "scroll",
                        padding: "5px",
                        backgroundColor: "#f7fafc",
                        color: "#525f7f;",
                        scrollbarBaseColor: "#DEBB07",
                        border: "ridge",
                        color: "indigo",
                      }}
                    >
                      {remedylist.job_log}
                    </div>
                  </div>
                </Row>
              </Container>
            ) : (
              <Container
                className="mt--10"
                fluid
                style={{ width: "100px", height: "100px" }}
              >
                <Spinner
                  style={{ color: "linear-gradient(40deg, #2096ff, #05ffa3)" }}
                />
              </Container>
            )}
          </CardContent>
        </Card>
      </Container>
    </>
  );
};

export default Log;